module.exports = __webpack_public_path__ + "static/media/judge.a96ff3d5.svg";